import {
  RESOURCES_REQUEST,
  RESOURCES_ME_REQUEST,
  RESOURCE_TYPE_REQUEST,
} from '../reducers/Resources';

export const getResources = (value, query) => ({
  type: RESOURCES_REQUEST,
  value,
  query,
});

export const getMyResources = () => ({ type: RESOURCES_ME_REQUEST });

export const getResourceTypes = () => ({ type: RESOURCE_TYPE_REQUEST });
